import type { TContactsFormFields, TCreditFormCommonFields } from 'entities/creditForm';

export const getContactsStepLabel = (
  formFields: TContactsFormFields,
  formFieldsLabels: Partial<Record<keyof TCreditFormCommonFields, string>>,
  stepFields: Array<keyof TContactsFormFields>,
) =>
  stepFields.map((key) => {
    switch (key) {
      default: {
        return {
          fieldLabel: String(formFieldsLabels[key]),
          fieldValue: String(formFields[key]),
        };
      }
    }
  });
